import React from 'react'
import { MdDelete, MdDetails, MdEdit } from 'react-icons/md'

const TableAction = ({ handleEditButton, handleDeleteButton, handleDetailButton }) => {
  return (
    <div className="flex  gap-2">
      {handleEditButton &&
        <div className="tooltip-container relative inline-block">
          <button className='rounded-md h-8 w-8 flex items-center justify-center border-2 border-violet-600 text-violet-500' onClick={handleEditButton}>
            <MdEdit />
          </button>
          <div id="tooltip-top" role="tooltip" className="text-xs mb-1 tooltip">
            Edit
            <div className="tooltip-arrow" data-popper-arrow></div>
          </div>
        </div>

      }
      {handleDeleteButton && <div className="tooltip-container relative inline-block">
        <button className='rounded-md h-8 w-8 flex items-center justify-center border-2 border-red-600 text-red-500' onClick={handleDeleteButton}>
        <MdDelete />
        <div id="tooltip-top" role="tooltip" className="text-xs mb-1 tooltip">
            Delete
            <div className="tooltip-arrow" data-popper-arrow></div>
          </div>
      </button>
      </div>
      }
      {
        handleDetailButton &&<div className="tooltip-container relative inline-block">
        <button className='rounded-md h-8 w-8 flex items-center justify-center border-2 border-green-600 text-green-500' onClick={handleDetailButton}>
          <MdDetails />
        </button>
        <div id="tooltip-top" role="tooltip" className="text-xs mb-1 tooltip">
            Details
            <div className="tooltip-arrow" data-popper-arrow></div>
          </div>
        </div>
      }

    </div>
  )
}

export default TableAction